class ReportTemplateCollection extends App.Collections.BaseCollection {
    url = 'ReportTemplate';
    model = App.Models.ReportTemplate;
}

App.Collections.ReportTemplates = ReportTemplateCollection;
